var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"statusSelector",class:{active: _vm.searchStatusIdsArray.includes(_vm.statusId)},on:{"click":_vm.setUnsetStatus}},[_vm._v(" "+_vm._s(_vm.statusName)+" "),_c('i',{staticClass:"fa fa-plus",attrs:{"aria-hidden":"true"}})])}
var staticRenderFns = []

export { render, staticRenderFns }